import * as React from 'react';
import Box from '@mui/material/Box';
import { Paper, useMediaQuery, useTheme } from '@mui/material';

export default function ResponsiveDrawer(props: Props): React.ReactElement {
    const { Header, children } = props;
    const theme = useTheme();
    const matches = useMediaQuery(theme.breakpoints.up('sm'));

    return (
        <Box className="header-wrapper review-container">
            <Box
                component={Paper}
                elevation={2}
                className={
                    matches
                        ? 'header-container sticky'
                        : 'header-container flat'
                }
            >
                <Header />
            </Box>
            <Box
                component="main"
                aria-label="container with footing menu"
                className="main-content"
            >
                {children}
            </Box>
        </Box>
    );
}
